export default {"src":"/_next/static/media/light-purple-to-light-blue-right.61cd7d25.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};